import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CalcRangeSelector } from "../CalcRangeSelector";
import { getHumanPeriodType } from "../../../helpers/helpers";
import { RUSSIAN_LOCALE } from "../../../helpers/const";
import CalendarIcon from "../../../img/svg/data-bg.svg?react";
import { selectLoan } from "@/store/selectors";

export const TermSelector = ({ selected, items = [], onSelect }) => {
  const amounts = useSelector(selectLoan);
  const [value, setValue] = useState(selected);
  return (
    <>
      <li className="item item-data">
        <ul className="form-list-in">
          <li>
            <div className="label">Срок займа</div>
            <div className="rub term-wrapper">
              <CalendarIcon alt="calendar icon" />
              <span>
                {value.number} {getHumanPeriodType(value)}
              </span>
            </div>
          </li>
          <li>
            <div className="label">Сумма переплаты:</div>
            <div className="rub">
              {amounts.overpaymentAmount?.toLocaleString(RUSSIAN_LOCALE)} ₽
            </div>
          </li>
        </ul>
      </li>
      <li className="item item--calculator-mobile progressbar">
        <CalcRangeSelector
          selected={selected}
          items={items}
          onChange={(item) => setValue(item)}
          onSelect={onSelect}
        />
      </li>
    </>
  );
};
